import type { NavigateFunction } from 'react-router-dom';

/**
 * Every entry point to the shoot view opens it the same way (mock-up §06):
 * a new tab from a desktop, where the page you came from is worth keeping
 * open, and in place from a phone, where a second tab is where pages go to
 * be lost.
 */

/** The decision on its own, so it can be tested without a DOM. */
export function shootViewTarget(matchesDesktop: boolean): 'tab' | 'inplace' {
  return matchesDesktop ? 'tab' : 'inplace';
}

interface ShootViewOptions {
  /** Runs only on the in-place branch (a phone). Resolve `false` to stay
   *  put, for example when the editor's autosave could not land: leaving
   *  would unmount the editor and lose the edit with it. */
  beforeNavigate?: () => Promise<boolean | void>;
  forceNewTab?: boolean;
}

export async function openShootView(
  url: string,
  navigate: NavigateFunction,
  { beforeNavigate, forceNewTab = false }: ShootViewOptions = {},
): Promise<void> {
  const matchesDesktop =
    typeof window !== 'undefined' && window.matchMedia('(min-width: 768px)').matches;
  if (forceNewTab || shootViewTarget(matchesDesktop) === 'tab') {
    window.open(url, '_blank', 'noopener');
  } else {
    if (beforeNavigate && (await beforeNavigate()) === false) return;
    navigate(url);
  }
}
